<template lang="html">
    <div>
        <div class="loader-wrap" v-if="!loaded">
            <div class="loader-content">
                <div class="loader">
                    <div class="loader__item">
                    </div>
                </div>
            </div>
        </div>

       <div class="content" v-else>
           <h1>Souhrn</h1>
       </div>
    </div>
</template>


<script>
    import { mapState } from 'vuex';

    export default {
        name: 'Overview',
        components: {
        },



        data() {
            return {
                loaded: false
            }
        },

        created() {




        },
        computed: {
            ...mapState(['profile']),

        },
        mounted(){
            this.loaded = true;
        },
        methods: {


        },
        watch: {

        }
    }
</script>


<style lang="scss">


</style>
